class TchrURL extends URL {
  constructor(route: string) {
    const baseUrl = import.meta.env.VITE_API_URL;


    super(route, baseUrl);
    return new URL(route, baseUrl);
  }
}

export default TchrURL;